import CommonNavBar from "views/components/CommonNavBar";
import { Dialog, Toast } from "react-vant";
import { useNavigate } from "react-router-dom";
import styles from "./SystemSetting.module.less";
import { useEffect, useRef, useState } from "react";
import DSBridge from "dsbridge";
import { logoutApi } from "@/api/mine";

function SystemSetting() {
  const navigate = useNavigate();
  const systemRef = useRef(null);
  const [appInfo, setAppInfo] = useState({});
  const LoadingRef = useRef(null);
  const options = [
    {
      title: "换绑手机号",
      icon: require("@/images/mine/system-setting/icon_phone.png"),
      onClick: () => {
        navigate("/mine/modifyPhone", {
          state: {
            lastRoute: "/mine/systemSetting",
          },
          replace: true,
        });
      },
    },
    {
      title: "修改密码",
      icon: require("@/images/mine/system-setting/icon_password.png"),
      onClick: () => {
        navigate("/mine/modifyPassword", { replace: true });
      },
    },
    {
      title: "设备管理",
      icon: require("@/images/mine/system-setting/icon_device.png"),
      onClick: () => {
        navigate("/mine/deviceManage");
      },
    },
    {
      title: "通知管理",
      icon: require("@/images/mine/system-setting/icon_report.png"),
      onClick: () => {
        DSBridge.call(
          "route.navigation",
          {
            route: "pushSettings",
          },
          (back) => {
            console.log(back);
          },
        );
      },
    },
    {
      title: "收货地址",
      icon: require("@/images/mine/system-setting/icon_address.png"),
      onClick: () => {
        navigate("/mine/mailingAddress");
      },
    },
    {
      title: "个人信息收集清单",
      icon: require("@/images/mine/system-setting/icon_person.png"),
      onClick: () => {
        navigate("/mine/personMessage");
      },
    },
    {
      title: "第三方信息共享清单",
      icon: require("@/images/mine/system-setting/icon_third.png"),
      onClick: () => {
        navigate(
          `/webUrlView?webUrl=${encodeURIComponent(
            `https://cdn03.myaitalk.vip/utalkrc/privacy/en/pocketlinghang-third-party-information-sharing-list-v5.html`,
          )}`,
        );
      },
    },
    {
      title: "算法备案公示",
      icon: require("@/images/mine/system-setting/icon_algorithm.png"),
      onClick: () => {
        Dialog.alert({
          title: "算法备案公示",
          teleport: systemRef.current,
          closeable: true,
          theme: "round-button",
          message: (
            <div className={styles["dialog-container"]}>
              <div>模型名称：</div>
              <div>文心大模型算法-2</div>
              <div>备案号：</div>
              <div>网信算备110108645502801230069号</div>
              <div>模型名称：</div>
              <div>百度语音合成算法</div>
              <div>备案号：</div>
              <div>网信算备110108645502801230043号</div>
            </div>
          ),
        });
      },
    },
    {
      title: "注销账号",
      icon: require("@/images/mine/system-setting/icon_off.png"),
      onClick: () => {
        navigate("/mine/logoff");
      },
    },
  ];
  const handleClickLogout = async () => {
    LoadingRef.current = Toast.loading({
      message: "正在退出登录...",
      forbidClick: true,
      duration: 0,
    });
    await logoutApi({
      device_id: appInfo?.deviceId,
      app_id: appInfo?.appId,
    });
    if (LoadingRef.current?.clear) {
      LoadingRef.current.clear();
      LoadingRef.current = null;
    }
    DSBridge.call("auth.logout");
    localStorage.clear();
    navigate("/login/logon", { replace: true });
  };
  useEffect(() => {
    try {
      const info = JSON.parse(DSBridge.call("getAppInfo"));
      setAppInfo(info.data || {});
    } catch (error) {
      console.log(error);
    }
    return () => {
      if (LoadingRef.current?.clear) {
        LoadingRef.current.clear();
      }
    };
  }, []);
  return (
    <div className={styles["system-setting-container"]} ref={systemRef}>
      <CommonNavBar
        onClickBack={() => {
          navigate("/main/mine", { replace: true });
        }}
        backgroundColor="#FAFAFA"
      />
      <div className={styles["top-title"]}>系统设置</div>
      <div className={styles["option-list"]}>
        {options.map((item, index) => (
          <div
            className={styles["option-list-item"]}
            key={`system-option-${index}`}
            onClick={item.onClick}
          >
            <div className={styles["item-left"]}>
              <img className={styles["item-left-icon"]} src={item.icon} />
              <div className={styles["item-left-title"]}>{item.title}</div>
            </div>
            {item.right ? (
              item.right
            ) : (
              <img
                className={styles["item-right"]}
                src={require("@/images/mine/system-setting/icon_right.png")}
              />
            )}
          </div>
        ))}
      </div>
      <div className={styles["logout-button"]} onClick={handleClickLogout}>
        退出登录
      </div>
      <div className={styles["filings-wrapper"]}>
        <div className={styles["filings-wrapper-item"]}>
          <span className={styles["filings-wrapper-item-title"]}>备案号</span>
          <span className={styles["filings-wrapper-item-text"]}>
            {appInfo?.recordNumber || "浙ICP备2023048684号-2A"}
          </span>
        </div>
        <div
          className={styles["filings-wrapper-item"]}
          onClick={() => {
            navigate(
              `/mine/webUrl?webUrl=
                https://beian.miit.gov.cn&title=${encodeURIComponent(
                  "查询链接",
                )}
              `,
            );
          }}
        >
          <span className={styles["filings-wrapper-item-title"]}>查询链接</span>
          <span className={styles["filings-wrapper-item-text"]}>
            {appInfo?.recordNumberLink || "https://beian.miit.gov.cn"}
          </span>
        </div>
      </div>
    </div>
  );
}
export default SystemSetting;
